import React from 'react';
import { FormControlLabel, Switch, FormHelperText } from '@material-ui/core';
import { Controller, useFormContext } from 'react-hook-form';

const RMSSwitch = ({ name, label, disabled = false, checked, onChange, classes }) => {
  const formContext = useFormContext();
  const isControlledExternally = checked !== undefined && typeof onChange === 'function';

  if (isControlledExternally) {
    const switchElement = (
      <Switch
        checked={!!checked}
        onChange={onChange}
        color="primary"
        disabled={disabled}
        classes={classes}
      />
    );
    return label ? <FormControlLabel control={switchElement} label={label} /> : switchElement;
  }

  const { control } = formContext;

  return (
    <Controller
      name={name}
      control={control}
      defaultValue={false}
      render={({ field, fieldState: { error } }) => (
        <>
          <FormControlLabel
            control={
              <Switch
                checked={!!field.value}
                onChange={(e) => field.onChange(e.target.checked)}
                color="primary"
                disabled={disabled}
                classes={classes}
              />
            }
            label={label}
          />
          {error && <FormHelperText error>{error.message}</FormHelperText>}
        </>
      )}
    />
  );
};

export default RMSSwitch;
